import React, {useState} from 'react';

import UncontrolledExhibitorsInteractiveMap from '../UncontrolledExhibitorsInteractiveMap';

const ExhibitorsInteractiveMap = props => {
    const {eventId} = props,
        [selected, setSelected] = useState(props.default);

    const handlePinClicked = id => {
        app.history.push(['/events', eventId, 'exhibitors', id.toString()].join('/'));
    };
    const handlePinSelected = id => {
        setSelected(id);
    };

    return <UncontrolledExhibitorsInteractiveMap {...props} selected={selected} onPinClicked={handlePinClicked} onPinSelected={handlePinSelected} />;
};

export default ExhibitorsInteractiveMap;
